export const getLayoutClass = (template: string, layout = '1') => {
  return `vitrine-template${template}--layout-${layout}`;
};
